<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  header: String,
  box: { type: Boolean, default: true },
  collapsible: { type: Boolean, default: false },
  collapsed: { type: Boolean, default: false },
  showHeader: { type: Boolean, default: true },
});

const expanded = ref(!props.collapsed);

watch(
  () => props.collapsed,
  (newVal) => {
    expanded.value = !newVal;
  },
);

const toggleExpand = () => {
  expanded.value = !expanded.value;
};
</script>

<template>
  <div :class="{ box: props.box }" class="w-full h-full">
    <div v-if="props.showHeader" class="flex justify-between items-start header-container gap-4">
      <header class="flex-1 font-semibold">
        <slot name="header">
          {{ props.header }}
        </slot>
      </header>

      <div class="flex items-center gap-2 whitespace-nowrap">
        <slot name="nav" />
        <button v-if="props.collapsible" class="cursor-pointer" @click.prevent="toggleExpand">
          <svg data-accordion-icon :class="['w-3 h-3 shrink-0 transition-transform', { 'rotate-180': expanded }]"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6" aria-hidden="true">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5 5 1 1 5" />
          </svg>
        </button>
      </div>
    </div>

    <hr v-if="props.showHeader" class="pb-2" />

    <slot v-if="expanded" />
  </div>
</template>
